import { useState } from 'react';

import { DEFAULT_SEARCH_SHORTCUT } from '@flipdish/ui-library/components/organisms/ApplicationHeader';
import { useHotkeys } from 'react-hotkeys-hook';

type Options = {
  /** False while search is gated off (flag off, restricted onboarding): the shortcut is not registered. */
  enabled: boolean;
};

/**
 * Holds whether the global search (the command menu) is open and registers the header's shortcut
 * once, so the key the header hints at is the key that opens it.
 *
 * @param options.enabled Whether search is available at all; the hotkey is off otherwise.
 * @returns The open state, the opener the header and sidebar bind to, and the change handler `CommandMenu` takes.
 */
export const useGlobalSearch = ({ enabled }: Options) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const open = () => setIsOpen(true);
  // Fires from form fields too, so the shortcut works while typing elsewhere on the page.
  useHotkeys(DEFAULT_SEARCH_SHORTCUT, open, {
    preventDefault: true,
    enableOnFormTags: true,
    enabled,
  });

  return { isOpen, open, onOpenChange: setIsOpen };
};

export type GlobalSearchState = ReturnType<typeof useGlobalSearch>;
